import { getConsoleBaseUrl } from '@kc-console/core';

const CONSOLE_BASE_URL = getConsoleBaseUrl();

export const EXTERNAL_SERVICE_LINK = {
  HELP_DESK: `${CONSOLE_BASE_URL}/helpdesk`,
  PROJECT_MANAGEMENT: `${CONSOLE_BASE_URL}/project`,
};

export const PORTAL_PATH = {
  PUBLIC_NOTICE_LIST: `/more/notices`,
  GOV_NOTICE_LIST: `/notices`,
};

const GOV_HELPDESK_MAIL = 'kc_helpdesk@kakaoenterprise.com';

const CONTACT_SUPPORT = 'https://help-kakaocloud.kakaoenterprise.com/hc/ko/requests/new';

export const EXTERNAL_LINK = {
  HELP_DESK: {
    QNA: `${EXTERNAL_SERVICE_LINK.HELP_DESK}/qna`,
    NOTICE: `${EXTERNAL_SERVICE_LINK.HELP_DESK}/notice`,
  },
  PROJECT_MANAGEMENT: {
    MEMBERS: `${EXTERNAL_SERVICE_LINK.PROJECT_MANAGEMENT}/users`,
  },
  PORTAL: PORTAL_PATH,
  GOV_HELPDESK_MAIL,
  CONTACT_SUPPORT,
};
